import { PipLayoutCell } from '../pipGrid';

/** Canonical pip layouts for values 0–12 (shared across all double-N sets). */
export const PIP_LAYOUTS: Record<number, readonly PipLayoutCell[]> = {
  0: [],
  1: [{ row: 1, col: 1, gridSize: '3x3' }],
  2: [
    { row: 0, col: 2, gridSize: '3x3' },
    { row: 2, col: 0, gridSize: '3x3' },
  ],
  3: [
    { row: 0, col: 2, gridSize: '3x3' },
    { row: 1, col: 1, gridSize: '3x3' },
    { row: 2, col: 0, gridSize: '3x3' },
  ],
  4: [
    { row: 0, col: 0, gridSize: '3x3' },
    { row: 0, col: 2, gridSize: '3x3' },
    { row: 2, col: 0, gridSize: '3x3' },
    { row: 2, col: 2, gridSize: '3x3' },
  ],
  5: [
    { row: 0, col: 0, gridSize: '3x3' },
    { row: 0, col: 2, gridSize: '3x3' },
    { row: 1, col: 1, gridSize: '3x3' },
    { row: 2, col: 0, gridSize: '3x3' },
    { row: 2, col: 2, gridSize: '3x3' },
  ],
  6: [
    { row: 0, col: 0, gridSize: '3x3' },
    { row: 0, col: 2, gridSize: '3x3' },
    { row: 1, col: 0, gridSize: '3x3' },
    { row: 1, col: 2, gridSize: '3x3' },
    { row: 2, col: 0, gridSize: '3x3' },
    { row: 2, col: 2, gridSize: '3x3' },
  ],
  7: [
    { row: 0, col: 0, gridSize: '3x3' },
    { row: 0, col: 2, gridSize: '3x3' },
    { row: 1, col: 0, gridSize: '3x3' },
    { row: 1, col: 1, gridSize: '3x3' },
    { row: 1, col: 2, gridSize: '3x3' },
    { row: 2, col: 0, gridSize: '3x3' },
    { row: 2, col: 2, gridSize: '3x3' },
  ],
  8: [
    { row: 0, col: 0, gridSize: '3x3' },
    { row: 0, col: 1, gridSize: '3x3' },
    { row: 0, col: 2, gridSize: '3x3' },
    { row: 1, col: 0, gridSize: '3x3' },
    { row: 1, col: 2, gridSize: '3x3' },
    { row: 2, col: 0, gridSize: '3x3' },
    { row: 2, col: 1, gridSize: '3x3' },
    { row: 2, col: 2, gridSize: '3x3' },
  ],
  9: [
    { row: 0, col: 0, gridSize: '3x3' },
    { row: 0, col: 1, gridSize: '3x3' },
    { row: 0, col: 2, gridSize: '3x3' },
    { row: 1, col: 0, gridSize: '3x3' },
    { row: 1, col: 1, gridSize: '3x3' },
    { row: 1, col: 2, gridSize: '3x3' },
    { row: 2, col: 0, gridSize: '3x3' },
    { row: 2, col: 1, gridSize: '3x3' },
    { row: 2, col: 2, gridSize: '3x3' },
  ],
  10: [
    { row: 0, col: 0, gridSize: '4x3' },
    { row: 0, col: 1, gridSize: '4x3' },
    { row: 0, col: 2, gridSize: '4x3' },
    { row: 1, col: 0, gridSize: '4x3' },
    { row: 1, col: 2, gridSize: '4x3' },
    { row: 2, col: 0, gridSize: '4x3' },
    { row: 2, col: 2, gridSize: '4x3' },
    { row: 3, col: 0, gridSize: '4x3' },
    { row: 3, col: 1, gridSize: '4x3' },
    { row: 3, col: 2, gridSize: '4x3' },
  ],
  11: [
    { row: 0, col: 0, gridSize: '4x3' },
    { row: 1, col: 0, gridSize: '4x3' },
    { row: 2, col: 0, gridSize: '4x3' },
    { row: 3, col: 0, gridSize: '4x3' },
    { row: 0, col: 1, gridSize: '4x3' },
    { row: 2, col: 1, gridSize: '4x3', top: '50%' },
    { row: 3, col: 1, gridSize: '4x3' },
    { row: 0, col: 2, gridSize: '4x3' },
    { row: 1, col: 2, gridSize: '4x3' },
    { row: 2, col: 2, gridSize: '4x3' },
    { row: 3, col: 2, gridSize: '4x3' },
  ],
  12: [
    { row: 0, col: 0, gridSize: '4x3' },
    { row: 1, col: 0, gridSize: '4x3' },
    { row: 2, col: 0, gridSize: '4x3' },
    { row: 3, col: 0, gridSize: '4x3' },
    { row: 0, col: 1, gridSize: '4x3' },
    { row: 1, col: 1, gridSize: '4x3' },
    { row: 2, col: 1, gridSize: '4x3' },
    { row: 3, col: 1, gridSize: '4x3' },
    { row: 0, col: 2, gridSize: '4x3' },
    { row: 1, col: 2, gridSize: '4x3' },
    { row: 2, col: 2, gridSize: '4x3' },
    { row: 3, col: 2, gridSize: '4x3' },
  ],
};
